import * as React from "react";
import Container from "./styled";
import { Fade } from "react-awesome-reveal";

export default function Pasos() {
  return (
    <Container>
      <Fade
        delay={100}
        duration={800}
        triggerOnce={true}
        className="pasosContainer"
      >
        {/* Paso 1 */}
        <div>
          {/* Image */}
          <img src="images/home/pasos/1.svg"></img>
          {/* Title */}
          <h3>Paso 1</h3>
          {/* Text */}
          <p>Solicitá tu cotización desde el formulario</p>
        </div>
      </Fade>
      <Fade
        delay={100}
        duration={800}
        triggerOnce={true}
        className="pasosContainer"
      >
        {/* Paso 2 */}
        <div>
          {/* Image */}
          <img src="images/home/pasos/2.svg"></img>
          {/* Title */}
          <h3>Paso 2</h3>
          {/* Text */}
          <p>Un asesor se pondrá en contacto con vos</p>
        </div>
      </Fade>
      <Fade
        delay={100}
        duration={800}
        triggerOnce={true}
        className="pasosContainer"
      >
        {/* Paso 3 */}
        <div>
          {/* Image */}
          <img src="images/home/pasos/3.svg"></img>
          {/* Title */}
          <h3>Paso 3</h3>
          {/* Text */}
          <p>Salí a pedalear seguro y sin preocupaciones</p>
        </div>
      </Fade>
    </Container>
  );
}
